import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useSite } from "@/context/SiteContext";
import { mediaUrl } from "@/lib/api";
import MaskedReveal from "@/components/marketing/MaskedReveal";

export default function About() {
  const { settings } = useSite();
  const s = settings || {};
  const story = (s.about_story || "").split(/\n+/).filter(Boolean);

  return (
    <main data-testid="about-page" className="bg-ivory text-ink pt-32 md:pt-40 pb-32">
      <section className="px-6 md:px-12 lg:px-16 grid grid-cols-12 gap-8">
        <div className="col-span-12 md:col-span-6">
          <p className="label-mono opacity-60 line-badge">About</p>
          <MaskedReveal
            as="h1"
            mode="load"
            delay={0.1}
            lines={["Cape Town", "photography &", "film studio."]}
            className="mt-8 font-editorial text-6xl md:text-8xl leading-[0.95]"
            lineClass="italic"
          />
          <p className="mt-8 label-mono opacity-70">
            {s.about_founder_role || "Photographer & Creative Director"} · {s.location || "Cape Town, South Africa"}
          </p>
        </div>
        <motion.div
          className="col-span-12 md:col-span-6"
          initial={{ opacity: 0, y: 60 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, ease: [0.19, 1, 0.22, 1] }}
        >
          <div className="photo-frame aspect-[4/5]">
            <img
              src={mediaUrl(s.about_founder_portrait) || "https://images.unsplash.com/photo-1489980478378-9899871dbca4?w=1400&q=85"}
              alt="Elvis Sereo, founder of Oereshaus"
            />
          </div>
        </motion.div>
      </section>

      <section className="px-6 md:px-12 lg:px-16 mt-24 md:mt-32 grid grid-cols-12 gap-8">
        <div className="col-span-12 md:col-span-3">
          <p className="label-mono opacity-60">The story</p>
        </div>
        <div className="col-span-12 md:col-span-8 space-y-8">
          {story.map((p, i) => (
            <motion.p
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.9, delay: i * 0.08 }}
              className={i === 0 ? "font-editorial text-3xl md:text-4xl italic leading-[1.2]" : "text-lg text-ink/80 leading-relaxed"}
            >
              {p}
            </motion.p>
          ))}
        </div>
      </section>

      <section className="px-6 md:px-12 lg:px-16 mt-32 border-t border-ink/15 pt-14 flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
        <h3 className="font-editorial text-4xl md:text-6xl max-w-2xl">
          {s.about_message || "Tell us what you are celebrating."}
        </h3>
        <div className="flex gap-4 flex-wrap">
          <Link to="/booking" className="btn-outline-ink" data-testid="about-cta-booking">Start Enquiry</Link>
          <Link to="/contact" className="btn-outline-ink" data-testid="about-cta-contact">Contact</Link>
        </div>
      </section>
    </main>
  );
}
